var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "ah-drawer"
    },
    [
      _c("img", {
        staticClass: "ah-drawer-close-button",
        attrs: { "aria-label": _vm.closeLabel, src: _vm.closeIconSrc },
        on: { click: _vm.toggle }
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }